import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LanguageSelector } from "@/components/LanguageSelector";
import { useLanguage } from "@/i18n/LanguageContext";
import logo from "@/assets/logo-fd-extended.png";

export const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { t } = useLanguage();
  const { pathname } = useLocation();
  const base = pathname === "/home" ? "" : "/home";

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { href: base + "#inicio", label: t("nav", "inicio") },
    { href: base + "#sobre-mi", label: t("nav", "sobreMi") },
    { href: base + "#cursos", label: t("nav", "cursos") },
    { href: base + "#servicios", label: t("nav", "servicios") },
    { href: "/consultoria-apertura-cafeterias", label: t("nav", "apertura") },
    { href: base + "#maquinas-bfc", label: t("nav", "maquinasBfc") },
    { href: base + "#contacto", label: t("nav", "contacto") },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "bg-background/95 backdrop-blur-md shadow-md" : "bg-transparent"
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-24">
          <Link to="/admin" className="flex items-center py-2 flex-1 max-w-2xl">
            <img src={logo} alt="Federico Duronio" className="h-20 w-full object-contain object-left" />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-6">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-foreground hover:text-gold transition-colors duration-300 font-medium"
              >
                {link.label}
              </a>
            ))}
            <LanguageSelector />
            <Button variant="premium" asChild>
              <a href={base + "#contacto"}>{t("nav", "reservarAhora")}</a>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-foreground"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label={isMobileMenuOpen ? "Cerrar menú de navegación" : "Abrir menú de navegación"}
            aria-expanded={isMobileMenuOpen}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-border bg-background">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="block py-3 text-foreground hover:text-gold transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <div className="py-3">
              <LanguageSelector />
            </div>
            <Button variant="premium" className="w-full mt-4" asChild>
              <a href={base + "#contacto"}>{t("nav", "reservarAhora")}</a>
            </Button>
          </div>
        )}
      </div>
    </nav>
  );
};
